import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
	Button,
	Card,
	CardActions,
	CardContent,
	CardHeader,
	Container,
	TextField,
	Grid,
	Checkbox,
	FormControlLabel,
	FormControl,
	Select,
	InputLabel,
	MenuItem,
	Typography,
} from "@material-ui/core";
import ImageUpload from "../../containers/upload/imageUpload";

const useStyles = makeStyles((theme) => ({
	cardRoot: {
		padding: "3vh 3%",
		"@media (max-width: 600px)": {
			padding: "3vh 0%",
			marginLeft: "-15px",
			width: "109%",
		},
	},
	cardContent: {
		display: "flex",
		flexDirection: "column",
	},
	cardActions: {
		display: "flex",
		justifyContent: "flex-end",
		paddingRight: "15px",
	},
	title: {
		margin: "5px 0",
	},
	input: {
		margin: "5px 0",
	},
}));

export default ({ title, onSubmit, loading, user }) => {
	const classes = useStyles();
	const [state, setState] = useState({
		firstName: user.firstName,
	});

	useEffect(() => {
		setState((prev) => ({ ...prev, ...user }));
	}, [user]);

	const handleChange = (event) => {
		const { id, value } = event.target;
		setState((prev) => ({
			...prev,
			[id]: id === "isLeader" ? !state.isLeader : value,
		}));
	};

	const handleRoleChange = (event) => {
		setState((prev) => ({
			...prev,
			role: event.target.value,
		}));
	};

	const handleFileUploaded = (fileUrl) =>
		setState((prevState) => ({ ...prevState, photoUrl: fileUrl }));

	const handleSubmit = () => {
		onSubmit({
			firstName: state.firstName,
			lastName: state.lastName,
			email: state.email,
			phoneNumber: state.phoneNumber,
			jobTitle: state.jobTitle,
			role: state.role,
			photoUrl: state.photoUrl,
			isLeader: state.isLeader,
		});
	};

	return (
		<Container justify="center" maxWidth="md">
			<Card className={classes.cardRoot}>
				<CardHeader title={title || "Article Form"} />
				<CardContent className={classes.cardContent}>
					<Grid container spacing={2}>
						<Grid item sm={12} md={6} xs={12}>
							<TextField
								fullWidth
								id="firstName"
								label="First Name"
								variant="outlined"
								className={classes.title}
								value={state.firstName}
								onChange={handleChange}
								required
							/>
						</Grid>
						<Grid item sm={12} md={6} xs={12}>
							<TextField
								fullWidth
								id="lastName"
								label="Last Name"
								variant="outlined"
								className={classes.title}
								value={state.lastName}
								onChange={handleChange}
								required
							/>
						</Grid>
					</Grid>
					<Grid container spacing={2}>
						<Grid item sm={12} md={6} xs={12}>
							<TextField
								fullWidth
								id="email"
								label="Email Address"
								variant="outlined"
								className={classes.title}
								value={state.email}
								onChange={handleChange}
								required
								type="email"
							/>
						</Grid>
						<Grid item sm={12} md={6} xs={12}>
							<TextField
								fullWidth
								id="phoneNumber"
								label="Phone Number"
								variant="outlined"
								className={classes.title}
								value={state.phoneNumber}
								onChange={handleChange}
								required
								type="tel"
							/>
						</Grid>
					</Grid>
					<Grid container spacing={2}>
						<Grid item sm={12} md={6} xs={12}>
							<TextField
								fullWidth
								id="jobTitle"
								label="Job Title"
								variant="outlined"
								className={classes.title}
								value={state.jobTitle}
								onChange={handleChange}
								required
							/>
						</Grid>
						<Grid item sm={12} md={6} xs={12}>
							<FormControl
								variant="outlined"
								className={classes.title}
								fullWidth
							>
								<InputLabel id="roleLabel">Role</InputLabel>
								<Select
									labelId="roleLabel"
									id="role"
									value={state.role}
									onChange={handleRoleChange}
									label="Role"
								>
									<MenuItem value="reader">Reader</MenuItem>
									<MenuItem value="editor">Content editor</MenuItem>
									<MenuItem value="admin">Administrator</MenuItem>
								</Select>
							</FormControl>
						</Grid>
					</Grid>
					<Grid container justifyContent="flex-end">
						<FormControlLabel
							control={
								<Checkbox
									checked={state.isLeader === true}
									onChange={handleChange}
									name="isLeader"
									id="isLeader"
									color="secondary"
								/>
							}
							label="Mark as leader"
						/>
					</Grid>

					<div className={classes.input}>
						<Typography variant="h6">Profile photo</Typography>
						<ImageUpload
							onFileUploaded={handleFileUploaded}
							defaultImg={state.photoUrl}
						/>
					</div>
				</CardContent>
				<CardActions className={classes.cardActions}>
					<Button
						disabled={loading}
						variant="outlined"
						onClick={handleSubmit}
						style={{
							color: "#E00186",
							border: "1px solid #E00186",
							"&:hover": {
								color: "#fff",
								backgroundColor: "#E00186",
								border: "1px solid #E00186",
							},
						}}
					>
						{loading ? "Saving..." : "Save"}
					</Button>
				</CardActions>
			</Card>
		</Container>
	);
};
